import { EstadoSubsidioMinvu, EstadoSubsidioMinvuCobro } from "../../../../utils/enums";

export const getFirstDayOfMonth = (date: Date): string => {
  const d = new Date(date);
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  return d.toISOString().split('T')[0]; // 'YYYY-MM-DD'
};

export const getLastDayOfMonth = (date: Date): string => {
  const d = new Date(date);
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  lastDay.setHours(0, 0, 0, 0);
  return lastDay.toISOString().split('T')[0]; // 'YYYY-MM-DD'
};
export const getDescriptionEstadoSubsidioMINVU = (type: string): string => {
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_NOGENERADO) return "No Generado";
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_GENERADO) return "Generado";
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_DESCARGADO) return "Descargado";
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_ENVIADO) return "Enviado";
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_VALIDADO) return "Validado";
  if (type === EstadoSubsidioMinvu.ESTADOSUBSIDIOMINVU_NOVALIDADO) return "No Validado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_NOENVIADO) return "No Enviado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_ENVIADO) return "Enviado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_DESCARGADO) return "Descargado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_GENERADO) return "Generado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_ACEPTADO) return "Aceptado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_RECHAZADO) return "Rechazado";
  if (type === EstadoSubsidioMinvuCobro.ESTADO_COBRO_MINVU_NOENVIADO) return "No Enviado";
  return "";
};